// Source of truth for supported UI languages.
// Order: default first, then largest European languages, then other major world languages.
// This ordering drives the language picker UI directly.
export const SUPPORTED_LANGUAGES = [
  // Default + primary market
  { code: 'en', name: 'English',             native: 'English',           flag: '🇬🇧', dir: 'ltr' },
  { code: 'sk', name: 'Slovak',              native: 'Slovenčina',        flag: '🇸🇰', dir: 'ltr' },
  // Largest European languages
  { code: 'de', name: 'German',              native: 'Deutsch',           flag: '🇩🇪', dir: 'ltr' },
  { code: 'fr', name: 'French',              native: 'Français',          flag: '🇫🇷', dir: 'ltr' },
  { code: 'es', name: 'Spanish',             native: 'Español',           flag: '🇪🇸', dir: 'ltr' },
  { code: 'it', name: 'Italian',             native: 'Italiano',          flag: '🇮🇹', dir: 'ltr' },
  { code: 'pl', name: 'Polish',              native: 'Polski',            flag: '🇵🇱', dir: 'ltr' },
  { code: 'pt', name: 'Portuguese',          native: 'Português',         flag: '🇵🇹', dir: 'ltr' },
  { code: 'ru', name: 'Russian',             native: 'Русский',           flag: '🇷🇺', dir: 'ltr' },
  { code: 'tr', name: 'Turkish',             native: 'Türkçe',            flag: '🇹🇷', dir: 'ltr' },
  // Major world languages
  { code: 'zh', name: 'Chinese (Simplified)', native: '中文',               flag: '🇨🇳', dir: 'ltr' },
  { code: 'ja', name: 'Japanese',            native: '日本語',              flag: '🇯🇵', dir: 'ltr' },
  { code: 'ko', name: 'Korean',              native: '한국어',              flag: '🇰🇷', dir: 'ltr' },
  { code: 'hi', name: 'Hindi',               native: 'हिन्दी',              flag: '🇮🇳', dir: 'ltr' },
  { code: 'ar', name: 'Arabic',              native: 'العربية',           flag: '🇸🇦', dir: 'rtl' },
  { code: 'bn', name: 'Bengali',             native: 'বাংলা',              flag: '🇧🇩', dir: 'ltr' },
  { code: 'id', name: 'Indonesian',          native: 'Bahasa Indonesia',  flag: '🇮🇩', dir: 'ltr' },
  { code: 'vi', name: 'Vietnamese',          native: 'Tiếng Việt',        flag: '🇻🇳', dir: 'ltr' },
  { code: 'ur', name: 'Urdu',                native: 'اردو',              flag: '🇵🇰', dir: 'rtl' },
  { code: 'mr', name: 'Marathi',             native: 'मराठी',              flag: '🇮🇳', dir: 'ltr' },
  { code: 'te', name: 'Telugu',              native: 'తెలుగు',             flag: '🇮🇳', dir: 'ltr' },
  { code: 'ta', name: 'Tamil',               native: 'தமிழ்',              flag: '🇮🇳', dir: 'ltr' },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

export const RTL_LANGUAGE_CODES = SUPPORTED_LANGUAGES
  .filter((l) => l.dir === 'rtl')
  .map((l) => l.code);

export const DEFAULT_LANGUAGE = 'en';

export const getLanguage = (code) =>
  SUPPORTED_LANGUAGES.find((l) => l.code === code) ||
  SUPPORTED_LANGUAGES.find((l) => l.code === DEFAULT_LANGUAGE);

export const isSupportedLanguage = (code) => SUPPORTED_LANGUAGE_CODES.includes(code);

// Pull `/<lang>` prefix off a pathname if present. Returns { lang, rest }.
// rest always begins with '/'. lang is null if the first segment is not a supported code.
export const splitLanguagePath = (pathname) => {
  const match = pathname.match(/^\/([a-z]{2})(?=\/|$)/i);
  if (match && isSupportedLanguage(match[1].toLowerCase())) {
    const lang = match[1].toLowerCase();
    const rest = pathname.slice(match[0].length) || '/';
    return { lang, rest };
  }
  return { lang: null, rest: pathname };
};
